import React, { useState } from "react";
import PaperVideoUploadFlow from "./PaperVideoUploadFlow";
import PaperVideoUpdateFlow from "./PaperVideoUpdateFlow";
import PaperVideoLookupFlow from "./PaperVideoLookupFlow";

type Mode = "upload" | "update" | "status";

const tabClass = (active: boolean) =>
  `flex-1 py-2.5 text-sm font-semibold text-center border-b-2 transition-colors ${
    active
      ? "border-slate-800 text-slate-900"
      : "border-transparent text-slate-500 hover:text-slate-700"
  }`;

export interface UpdateRedirectSeed {
  paperId: string;
  nonce: number;
}

function PaperVideoPage() {
  const [mode, setMode] = useState<Mode>("upload");
  const [updateRedirectSeed, setUpdateRedirectSeed] =
    useState<UpdateRedirectSeed | null>(null);

  function handleExistingPaperId(paperId: string) {
    setUpdateRedirectSeed({ paperId, nonce: Date.now() });
    setMode("update");
  }

  return (
    <div className="eh-page mx-auto py-8 mb-24 px-2 max-w-[560px]">
      <div className="eh-card shadow-sm">
        <p className="text-xs font-semibold uppercase tracking-wide text-slate-500 mb-2">
          Events House
        </p>
        <h1 className="text-2xl font-bold text-slate-900 mb-2">
          Paper presentation video
        </h1>
        <p className="text-sm text-slate-600 mb-6 leading-relaxed">
          Upload your recorded presentation video, update the details on an
          existing submission, or check its status.
        </p>

        <div className="flex border-b border-slate-200 mb-6">
          <button
            type="button"
            className={tabClass(mode === "upload")}
            onClick={() => setMode("upload")}
          >
            Upload new video
          </button>
          <button
            type="button"
            className={tabClass(mode === "update")}
            onClick={() => setMode("update")}
          >
            Update existing upload
          </button>
          <button
            type="button"
            className={tabClass(mode === "status")}
            onClick={() => setMode("status")}
          >
            Check status
          </button>
        </div>

        {mode === "upload" && (
          <PaperVideoUploadFlow onExistingPaperId={handleExistingPaperId} />
        )}
        {mode === "update" && (
          <PaperVideoUpdateFlow initialPaperId={updateRedirectSeed} />
        )}
        {mode === "status" && <PaperVideoLookupFlow />}
      </div>
    </div>
  );
}

export default PaperVideoPage;
